import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { FaSearch, } from "react-icons/fa";


function SaleHistory({ clientData }) {
  const navigate = useNavigate();
  const [expenseBill, setExpenseBill] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [invoiceSearch, setInvoiceSearch] = useState("");
  const [partySearchTerm, setPartySearchTerm] = useState("")
    console.log(clientData)
  const handleDownload = (item) => {


  let items = [];

  try {
    items = Array.isArray(item.items)
      ? item.items
      : JSON.parse(item.items || "[]");
  } catch (error) {
    console.error("Items parse error:", error);
    items = [];
  }



const getImageUrl = (image) => {
  if (!image) return "";

  const imageString = String(image).trim();

  // Already complete URL
  if (
    imageString.startsWith("http://") ||
    imageString.startsWith("https://") ||
    imageString.startsWith("data:image/")
  ) {
    return imageString;
  }

  // Backend uploaded image
  return `https://api.dectwinbilling.com/dUploads/${encodeURIComponent(imageString)}`;
};

// const signatureImage = getImageUrl(item.sign);
const signatureImage = getImageUrl(clientData?.sign);
  const toNumber = (value, fallback = 0) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return fallback;
    }

    const number = Number(
      String(value)
        .replace(/,/g, "")
        .replace("%", "")
        .trim()
    );

    return Number.isFinite(number)
      ? number
      : fallback;
  };

  // =========================================================
  // SAFE TEXT
  // =========================================================

  const safeText = (value, fallback = "NA") => {
    if (
      value === null ||
      value === undefined ||
      String(value).trim() === ""
    ) {
      return fallback;
    }

    return String(value);
  };

  // =========================================================
  // BASIC TOTALS
  // =========================================================

  const payableAmount = toNumber(
    item.payable
  );

  const receivedAmount = toNumber(
    item.received
  );

  const dueAmount = toNumber(
    item.due
  );

  // =========================================================
  // TAX
  // =========================================================

  const totalTax = toNumber(
    item.totalTax ??
    item.tax ??
    (
      toNumber(item.igst) +
      toNumber(item.cgst) +
      toNumber(item.sgst)
    )
  );

  // =========================================================
  // GROSS AMOUNT
  // =========================================================
  // Your data:
  // totalSP = 20
  //
  // Earlier data:
  // totalSP = 41436
  // =========================================================

  const grossAmount = toNumber(
    item.totalSP ??
    item.grossAmount ??
    0
  );

  // =========================================================
  // LAST DISCOUNT
  // =========================================================
  //
  // IMPORTANT:
  //
  // Use these fields:
  //
  // last_discount
  // last_discount_type
  //
  // NOT totalDis / onChangeForDiscount
  // =========================================================

  const lastDiscount = toNumber(
    item.last_discount
  );

  const lastDiscountType = String(
    item.last_discount_type ??
    ""
  )
    .trim()
    .toLowerCase();

  // =========================================================
  // DISCOUNT CALCULATION
  // =========================================================

  let discountAmount = 0;

  let discountLabel = "Discount";

  // ---------------------------------------------------------
  // AMOUNT DISCOUNT
  // ---------------------------------------------------------
  //
  // Example:
  //
  // last_discount = 1
  // last_discount_type = "Amount"
  //
  // Discount = ₹1
  // ---------------------------------------------------------

  if (
    lastDiscountType === "amount" ||
    lastDiscountType === "₹" ||
    lastDiscountType === "rs" ||
    lastDiscountType === "rupees"
  ) {
    discountAmount = lastDiscount;

    discountLabel =
      `Discount (₹${lastDiscount.toFixed(2)})`;
  }

  // ---------------------------------------------------------
  // PERCENTAGE DISCOUNT
  // ---------------------------------------------------------
  //
  // Example:
  //
  // last_discount = 39
  // last_discount_type = "Percentage"
  //
  // Use the final invoice numbers so that:
  //
  // Gross + Tax - Discount = Payable
  //
  // ---------------------------------------------------------

  else if (
    lastDiscountType === "percentage" ||
    lastDiscountType === "percent" ||
    lastDiscountType === "%"
  ) {
    discountLabel =
      `Discount (${lastDiscount}%)`;

    // First try to derive the actual discount
    // from the saved invoice totals.

    discountAmount =
      grossAmount +
      totalTax -
      payableAmount;

    // Prevent negative value.

    if (discountAmount < 0) {
      discountAmount = 0;
    }
  }

  // ---------------------------------------------------------
  // FALLBACK
  // ---------------------------------------------------------

  else {
    discountAmount = toNumber(
      item.totalDis ??
      item.discount ??
      0
    );

    if (lastDiscount > 0) {
      discountLabel =
        `Discount (${lastDiscount})`;
    }
  }

  // =========================================================
  // TOTAL QUANTITY
  // =========================================================

  const totalQuantity = items.reduce(
    (sum, itm) => {
      return (
        sum +
        toNumber(
          itm.qty ??
          itm.quantity ??
          itm.quant ??
          0
        )
      );
    },
    0
  );

  // =========================================================
  // OPEN PRINT WINDOW
  // =========================================================

  const invoiceWindow = window.open(
    "",
    "_blank",
    "width=1000,height=800"
  );

  if (!invoiceWindow) {
    alert(
      "Please allow pop-ups to print/download the invoice."
    );

    return;
  }

  // =========================================================
  // HTML
  // =========================================================

  invoiceWindow.document.write(`
<!DOCTYPE html>

<html>

<head>

<meta charset="UTF-8">

<title>
  Tax Invoice - ${safeText(item.invoiceNo, "")}
</title>

<style>

* {
  box-sizing: border-box;
}

@page {
  size: A4;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
  background: #333;
  font-family: Arial, Helvetica, sans-serif;
  color: #222;
  font-size: 14px;
}

.invoice-page {
  width: 210mm;
  min-height: 297mm;
  margin: 15px auto;
  background: #fff;
  padding: 10mm;
  position: relative;
}

/* =========================================================
   TITLE
========================================================= */

.invoice-title {
  text-align: center;
  color: #a020b5;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 14px;
  letter-spacing: 0.5px;
}

/* =========================================================
   COMPANY
========================================================= */

.company-box {
  border: 1.5px solid #c22bd2;
  padding: 10px;
  min-height: 75px;
  border-radius: 2px;
}

.company-name {
  color: #a020b5;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 5px;
}

.company-details {
  font-size: 14px;
  line-height: 21px;
}

/* =========================================================
   CUSTOMER
========================================================= */

.customer-row {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  font-size: 14px;
  line-height: 22px;
}

.customer-left {
  width: 52%;
}

.customer-right {
  width: 43%;
}

.customer-left b,
.customer-right b {
  font-weight: bold;
}

/* =========================================================
   TABLE
========================================================= */

table {
  width: 100%;
  border-collapse: collapse;
}

.items-table {
  margin-top: 14px;
  font-size: 13px;
}

.items-table th {
  background: #9c27b0;
  color: #fff;
  border: 1px solid #555;
  padding: 10px 7px;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
}

.items-table td {
  border: 1px solid #555;
  padding: 10px 7px;
  text-align: center;
  font-size: 13px;
  line-height: 18px;
}

.items-table td:first-child {
  text-align: left;
}

/* =========================================================
   SUMMARY
========================================================= */

.summary-section {
  display: flex;
  margin-top: 14px;
  font-size: 14px;
}

.summary-left {
  width: 50%;
  padding-right: 15px;
}

.summary-right {
  width: 50%;
  padding-left: 15px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 14px;
  line-height: 20px;
}

.summary-label {
  color: #a020b5;
  font-weight: bold;
}

.summary-value {
  font-weight: bold;
}

.amount-words {
  margin-top: 14px;
  font-size: 14px;
  line-height: 21px;
}

/* =========================================================
   DESCRIPTION
========================================================= */

.description {
  margin-top: 16px;
  font-size: 14px;
  line-height: 21px;
  border-top: 1px solid #ddd;
  padding-top: 8px;
}

/* =========================================================
   SIGNATURE
========================================================= */

/* =========================================================
   SIGNATURE
========================================================= */

.signature {
  position: absolute;
  bottom: 10mm;
  right: 10mm;
  width: 45mm;
  text-align: center;
  font-size: 12px;
}

.signature-image-wrapper {
  width: 40mm;
  height: 18mm;
  margin: 0 auto 4px auto;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;
}

.signature-image {
  display: block;
  max-width: 32mm;
  max-height: 15mm;
  width: auto;
  height: auto;
  object-fit: contain;
}

.signature-logo {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 14px;
}

.signature-text {
  font-size: 12px;
  font-weight: bold;
  border-top: 1px solid #222;
  padding-top: 4px;
  white-space: nowrap;
}
/* =========================================================
   PRINT
========================================================= */

@media print {

  body {
    background: #fff;
    margin: 0;
    padding: 0;
  }

  .invoice-page {
    margin: 0;
    width: 210mm;
    min-height: 297mm;
    padding: 10mm;
    box-shadow: none;
  }

}

</style>

</head>


<body>


<div class="invoice-page">


<!-- =====================================================
     TITLE
===================================================== -->

<div class="invoice-title">
  TAX INVOICE
</div>


<!-- =====================================================
     COMPANY DETAILS
===================================================== -->

<div class="company-box">

  <div class="company-name">

    ${safeText(
      item.company_name,
      "TESTING ACCOUNT"
    )}

  </div>


  <div class="company-details">

    <b>GSTIN:</b>

    ${safeText(
      item.gstin,
      "NA"
    )}

    <br>


    <b>CONTACT:</b>

    ${safeText(
      item.contact ??
      item.contact_number ??
      item.mobile,
      "NA"
    )}

    <br>


    <b>ADDRESS:</b>

    ${safeText(
      item.company_address,
      "GEORGE TOWN, PRAYAGRAJ"
    )}

  </div>

</div>


<!-- =====================================================
     CUSTOMER + INVOICE
===================================================== -->

<div class="customer-row">


  <div class="customer-left">

    <b>Billed To:</b>

    ${safeText(
      item.name,
      "Cash Customer"
    )}

    <br>


    <b>Address:</b>

    ${safeText(
      item.address,
      "NA"
    )}

    <br>


    <b>Contact:</b>

    ${safeText(
      item.mobile,
      "NA"
    )}

  </div>


  <div class="customer-right">

    <b>Invoice Number:</b>

    ${safeText(
      item.invoiceNo,
      ""
    )}

    <br>


    <b>Invoice Date:</b>

    ${safeText(
      item.date,
      ""
    )}

    <br>


    <b>Customer GST:</b>

    ${safeText(
      item.customer_gst ??
      item.customerGST ??
      item.customer_gstin,
      "NA"
    )}

  </div>

</div>


<!-- =====================================================
     ITEMS TABLE
===================================================== -->

<table class="items-table">


<thead>

<tr>

  <th>
    Item Name
  </th>

  <th>
    Qty
  </th>

  <th>
    Unit Price
  </th>

  <th>
    Discount
  </th>

  <th>
    Tax
  </th>

  <th>
    Total
  </th>

</tr>

</thead>


<tbody>


${
  items.length > 0

    ? items
        .map((itm) => {

          // ===============================================
          // ITEM NAME
          // ===============================================

          const itemName =
            itm.name ??
            itm.item ??
            itm.item_name ??
            "";


          // ===============================================
          // QUANTITY
          // ===============================================

          const qty =
            toNumber(
              itm.qty ??
              itm.quantity ??
              itm.quant ??
              0
            );


          // ===============================================
          // UNIT PRICE
          // ===============================================

          const price =
            toNumber(
              itm.price ??
              itm.unitPrice ??
              itm.rate ??
              itm.unit_price ??
              itm.price_per_unit ??
              0
            );


          // ===============================================
          // ITEM DISCOUNT
          // ===============================================

          const itemDiscount =
            toNumber(
              itm.discount ??
              0
            );


          // ===============================================
          // TAX RATE
          // ===============================================

          const taxRateText =
            itm.taxRate ??
            itm.tax_rate ??
            itm.taxPercentage ??
            itm.tax_percentage ??
            itm.taxPercent ??
            itm.gst ??
            itm.tax ??
            "";


          const taxRateString =
            String(
              taxRateText ?? ""
            ).trim();


          // ===============================================
          // TAX DISPLAY
          // ===============================================

          const extractedTaxPercent =
            taxRateString.match(
              /(\\d+(?:\\.\\d+)?)\\s*%/
            );


          const itemTaxPercent =
            extractedTaxPercent
              ? toNumber(
                  extractedTaxPercent[1]
                )
              : toNumber(
                  taxRateString,
                  0
                );


          const displayTax =
            taxRateString ||
            (
              itemTaxPercent > 0
                ? `${itemTaxPercent.toFixed(2)}%`
                : "0.00%"
            );


          // ===============================================
          // ITEM TAX AMOUNT
          // ===============================================

          const itemTaxAmount =
            toNumber(
              itm.taxAmount ??
              0
            );


          // ===============================================
          // ITEM TOTAL
          // ===============================================

          const itemTotal =
            toNumber(
              itm.amount ??
              itm.total ??
              (
                qty * price +
                itemTaxAmount -
                itemDiscount
              )
            );


          return `

<tr>

  <td>
    ${safeText(itemName, "")}
  </td>

  <td>
    ${qty}
  </td>

  <td>
    ₹${price.toFixed(2)}
  </td>

  <td>
    ₹${itemDiscount.toFixed(2)}
  </td>

  <td>
    ${displayTax}
  </td>

  <td>
    ₹${itemTotal.toFixed(2)}
  </td>

</tr>

`;

        })
        .join("")

    : `

<tr>

  <td colspan="6">
    No Items
  </td>

</tr>

`
}


</tbody>

</table>


<!-- =====================================================
     SUMMARY
===================================================== -->

<div class="summary-section">


  <!-- ===================================================
       LEFT
  =================================================== -->

  <div class="summary-left">


    <div class="summary-row">

      <span>
        <b>
          Total Quantity
        </b>
      </span>


      <span>
        <b>
          ${totalQuantity}
        </b>
      </span>

    </div>


    <div class="amount-words">

      <b>
        Amount in Words:
      </b>

      <br>

      <b>

        ${safeText(
          item.amount_words ??
          item.amountInWords,
          "Total Amount"
        )}

      </b>

    </div>


  </div>


  <!-- ===================================================
       RIGHT
  =================================================== -->

  <div class="summary-right">


    <!-- GROSS -->

    <div class="summary-row">

      <span class="summary-label">
        Gross Amount
      </span>

      <span class="summary-value">
        ₹${grossAmount.toFixed(2)}
      </span>

    </div>


    <!-- TAX -->

    <div class="summary-row">

      <span class="summary-label">
        Total Tax
      </span>

      <span class="summary-value">
        ₹${totalTax.toFixed(2)}
      </span>

    </div>


    <!-- DISCOUNT -->

    <div class="summary-row">

      <span class="summary-label">
        ${discountLabel}
      </span>

      <span class="summary-value">
        ₹${discountAmount.toFixed(2)}
      </span>

    </div>


    <!-- PAYABLE -->

    <div class="summary-row">

      <span class="summary-label">
        Payable Amount
      </span>

      <span class="summary-value">
        ₹${payableAmount.toFixed(2)}
      </span>

    </div>


    <!-- RECEIVED -->

    <div class="summary-row">

      <span class="summary-label">
        Received
      </span>

      <span class="summary-value">
        ₹${receivedAmount.toFixed(2)}
      </span>

    </div>


    <!-- DUE -->

    <div class="summary-row">

      <span class="summary-label">
        Due Amount
      </span>

      <span class="summary-value">
        ₹${dueAmount.toFixed(2)}
      </span>

    </div>


  </div>


</div>


<!-- =====================================================
     DESCRIPTION
===================================================== -->

<div class="description">

  <b>
    Description:
  </b>

  ${safeText(
    item.description,
    "NA"
  )}

</div>


<!-- =====================================================
     SIGNATURE
===================================================== -->

<div class="signature">
  ${
    signatureImage
      ? `
        <div class="signature-image-wrapper">
          <img
            src="${signatureImage}"
            class="signature-image"
            alt="Authority Signature"
          />
        </div>
      `
      : `
        <div class="signature-logo">
          ✓ Company
        </div>
      `
  }

  <div class="signature-text">
    Authority's Signature
  </div>
</div>


<!-- =====================================================
     AUTO PRINT
===================================================== -->

<script>

window.onload = function () {

  setTimeout(function () {

    window.print();

  }, 500);

};


window.onafterprint = function () {

  setTimeout(function () {

    window.close();

  }, 300);

};

</script>


</body>

</html>
  `);

  invoiceWindow.document.close();
};
// const handleDownload = (item) => {
//   let items = [];

//   // =========================
//   // PARSE ITEMS
//   // =========================
//   try {
//     items = Array.isArray(item.items)
//       ? item.items
//       : JSON.parse(item.items || "[]");
//   } catch (error) {
//     console.log("Items parse error:", error);
//     items = [];
//   }

//   // =========================
//   // SAFE NUMBER HELPER
//   // =========================
//   const toNumber = (value, fallback = 0) => {
//     if (
//       value === null ||
//       value === undefined ||
//       value === ""
//     ) {
//       return fallback;
//     }

//     const number = Number(
//       String(value)
//         .replace(/,/g, "")
//         .replace("%", "")
//         .trim()
//     );

//     return Number.isFinite(number)
//       ? number
//       : fallback;
//   };

//   // =========================
//   // SAFE TEXT HELPER
//   // =========================
//   const safeText = (value, fallback = "NA") => {
//     if (
//       value === null ||
//       value === undefined ||
//       String(value).trim() === ""
//     ) {
//       return fallback;
//     }

//     return String(value);
//   };

//   // =========================
//   // INVOICE TOTALS
//   // =========================

//   const total = toNumber(
//     item.payable
//   );

//   const discount = toNumber(
//     item.totalDis ??
//     item.discount ??
//     0
//   );

//   const tax = toNumber(
//     item.totalTax ??
//     item.tax ??
//     (
//       toNumber(item.igst) +
//       toNumber(item.cgst) +
//       toNumber(item.sgst)
//     )
//   );

//   const received = toNumber(
//     item.received
//   );

//   const due = toNumber(
//     item.due
//   );

//   // =========================
//   // GROSS AMOUNT
//   // =========================
//   const grossAmount = toNumber(
//     item.totalSP ??
//     item.grossAmount ??
//     (total + discount)
//   );

//   // =========================
//   // TOTAL QUANTITY
//   // =========================
//   const totalQuantity = items.reduce(
//     (sum, itm) => {
//       return (
//         sum +
//         toNumber(
//           itm.qty ??
//           itm.quantity ??
//           itm.quant ??
//           0
//         )
//       );
//     },
//     0
//   );

//   // =========================
//   // OPEN PRINT WINDOW
//   // =========================
//   const invoiceWindow = window.open(
//     "",
//     "_blank",
//     "width=1000,height=800"
//   );

//   if (!invoiceWindow) {
//     alert(
//       "Please allow pop-ups to download/print the invoice."
//     );
//     return;
//   }

//   invoiceWindow.document.write(`
//     <!DOCTYPE html>

//     <html>

//     <head>

//       <meta charset="UTF-8" />

//       <title>
//         Tax Invoice - ${safeText(item.invoiceNo, "")}
//       </title>

//       <style>

//         * {
//           box-sizing: border-box;
//         }

//         @page {
//           size: A4;
//           margin: 0;
//         }

//         body {
//           margin: 0;
//           padding: 0;
//           background: #333;
//           font-family: Arial, Helvetica, sans-serif;
//           color: #222;
//           font-size: 11px;
//         }

//         .invoice-page {
//           width: 210mm;
//           min-height: 297mm;
//           margin: 15px auto;
//           background: #fff;
//           padding: 10mm;
//           position: relative;
//         }

//         /* =========================
//            TITLE
//         ========================= */

//         .invoice-title {
//           text-align: center;
//           color: #a020b5;
//           font-size: 20px;
//           font-weight: bold;
//           margin-bottom: 10px;
//           letter-spacing: 0.5px;
//         }

//         /* =========================
//            COMPANY
//         ========================= */

//         .company-box {
//           border: 1.5px solid #c22bd2;
//           padding: 10px;
//           min-height: 75px;
//           border-radius: 2px;
//         }

//         .company-name {
//           color: #a020b5;
//           font-size: 17px;
//           font-weight: bold;
//           margin-bottom: 5px;
//         }

//         .company-details {
//           font-size: 11px;
//           line-height: 17px;
//         }

//         /* =========================
//            CUSTOMER
//         ========================= */

//         .customer-row {
//           display: flex;
//           justify-content: space-between;
//           margin-top: 12px;
//           font-size: 11px;
//           line-height: 18px;
//         }

//         .customer-left {
//           width: 52%;
//         }

//         .customer-right {
//           width: 43%;
//         }

//         .customer-left b,
//         .customer-right b {
//           font-weight: bold;
//         }

//         /* =========================
//            ITEMS TABLE
//         ========================= */

//         table {
//           width: 100%;
//           border-collapse: collapse;
//         }

//         .items-table {
//           margin-top: 12px;
//           font-size: 10.5px;
//         }

//         .items-table th {
//           background: #9c27b0;
//           color: #fff;
//           border: 1px solid #555;
//           padding: 8px 5px;
//           text-align: center;
//           font-size: 10.5px;
//           font-weight: bold;
//         }

//         .items-table td {
//           border: 1px solid #555;
//           padding: 8px 5px;
//           text-align: center;
//           font-size: 10.5px;
//           line-height: 15px;
//         }

//         .items-table td:first-child {
//           text-align: left;
//         }

//         /* =========================
//            SUMMARY
//         ========================= */

//         .summary-section {
//           display: flex;
//           margin-top: 12px;
//           font-size: 11px;
//         }

//         .summary-left {
//           width: 50%;
//           padding-right: 15px;
//         }

//         .summary-right {
//           width: 50%;
//           padding-left: 15px;
//         }

//         .summary-row {
//           display: flex;
//           justify-content: space-between;
//           padding: 4px 0;
//           font-size: 11px;
//           line-height: 17px;
//         }

//         .summary-label {
//           color: #a020b5;
//           font-weight: bold;
//         }

//         .summary-value {
//           font-weight: bold;
//         }

//         .amount-words {
//           margin-top: 12px;
//           font-size: 11px;
//           line-height: 18px;
//         }

//         /* =========================
//            DESCRIPTION
//         ========================= */

//         .description {
//           margin-top: 15px;
//           font-size: 11px;
//           line-height: 18px;
//           border-top: 1px solid #ddd;
//           padding-top: 8px;
//         }

//         /* =========================
//            SIGNATURE
//         ========================= */

//         .signature {
//           position: absolute;
//           bottom: 12mm;
//           left: 10mm;
//           font-size: 11px;
//         }

//         .signature-logo {
//           color: green;
//           font-size: 13px;
//           font-weight: bold;
//           margin-bottom: 20px;
//         }

//         .signature-text {
//           font-size: 11px;
//           font-weight: bold;
//         }

//         /* =========================
//            PRINT
//         ========================= */

//         @media print {

//           body {
//             background: #fff;
//             margin: 0;
//             padding: 0;
//           }

//           .invoice-page {
//             margin: 0;
//             width: 210mm;
//             min-height: 297mm;
//             padding: 10mm;
//             box-shadow: none;
//           }

//         }

//       </style>

//     </head>


//     <body>

//       <div class="invoice-page">

//         <!-- =========================
//              TITLE
//         ========================= -->

//         <div class="invoice-title">
//           TAX INVOICE
//         </div>


//         <!-- =========================
//              COMPANY DETAILS
//         ========================= -->

//         <div class="company-box">

//           <div class="company-name">
//             ${safeText(
//               item.company_name,
//               "TESTING ACCOUNT"
//             )}
//           </div>

//           <div class="company-details">

//             <b>GSTIN:</b>
//             ${safeText(
//               item.gstin,
//               "NA"
//             )}

//             <br>

//             <b>CONTACT:</b>
//             ${safeText(
//               item.contact ??
//               item.contact_number ??
//               item.mobile,
//               "NA"
//             )}

//             <br>

//             <b>ADDRESS:</b>
//             ${safeText(
//               item.company_address,
//               "GEORGE TOWN, PRAYAGRAJ"
//             )}

//           </div>

//         </div>


//         <!-- =========================
//              CUSTOMER + INVOICE
//         ========================= -->

//         <div class="customer-row">

//           <div class="customer-left">

//             <b>Billed To:</b>
//             ${safeText(
//               item.name,
//               "Cash Customer"
//             )}

//             <br>

//             <b>Address:</b>
//             ${safeText(
//               item.address,
//               "NA"
//             )}

//             <br>

//             <b>Contact:</b>
//             ${safeText(
//               item.mobile,
//               "NA"
//             )}

//           </div>


//           <div class="customer-right">

//             <b>Invoice Number:</b>
//             ${safeText(
//               item.invoiceNo,
//               ""
//             )}

//             <br>

//             <b>Invoice Date:</b>
//             ${safeText(
//               item.date,
//               ""
//             )}

//             <br>

//             <b>Customer GST:</b>
//             ${safeText(
//               item.customer_gst ??
//               item.customerGST ??
//               item.customer_gstin,
//               "NA"
//             )}

//           </div>

//         </div>


//         <!-- =========================
//              ITEMS TABLE
//         ========================= -->

//         <table class="items-table">

//           <thead>

//             <tr>

//               <th>
//                 Item Name
//               </th>

//               <th>
//                 Qty
//               </th>

//               <th>
//                 Unit Price
//               </th>

//               <th>
//                 Discount
//               </th>

//               <th>
//                 Tax
//               </th>

//               <th>
//                 Total
//               </th>

//             </tr>

//           </thead>


//           <tbody>

//             ${
//               items.length > 0

//                 ? items
//                     .map((itm) => {

//                       // =========================
//                       // ITEM NAME
//                       // =========================

//                       const itemName =
//                         itm.name ??
//                         itm.item ??
//                         itm.item_name ??
//                         "";


//                       // =========================
//                       // QUANTITY
//                       // =========================
//                       // Actual JSON:
//                       // quant: 12
//                       // =========================

//                       const qty = toNumber(
//                         itm.qty ??
//                         itm.quantity ??
//                         itm.quant ??
//                         0
//                       );


//                       // =========================
//                       // UNIT PRICE
//                       // =========================
//                       // Actual JSON:
//                       // price_per_unit: 3453
//                       // =========================

//                       const price = toNumber(
//                         itm.price ??
//                         itm.unitPrice ??
//                         itm.rate ??
//                         itm.unit_price ??
//                         itm.price_per_unit ??
//                         0
//                       );


//                       // =========================
//                       // DISCOUNT
//                       // =========================

//                       const itemDiscount =
//                         toNumber(
//                           itm.discount ??
//                           0
//                         );


//                       // =========================
//                       // TAX RATE
//                       // =========================
//                       // Actual JSON:
//                       // taxRate: "IGST 3%"
//                       // =========================

//                       const taxRateText =
//                         itm.taxRate ??
//                         itm.tax_rate ??
//                         itm.taxPercentage ??
//                         itm.tax_percentage ??
//                         itm.taxPercent ??
//                         itm.gst ??
//                         itm.tax ??
//                         "";


//                       const taxRateString =
//                         String(
//                           taxRateText ?? ""
//                         ).trim();


//                       // =========================
//                       // EXTRACT TAX %
//                       // =========================

//                       const extractedTaxPercent =
//                         taxRateString.match(
//                           /(\d+(?:\.\d+)?)\s*%/
//                         );


//                       const itemTaxPercent =
//                         extractedTaxPercent
//                           ? toNumber(
//                               extractedTaxPercent[1]
//                             )
//                           : toNumber(
//                               taxRateString,
//                               0
//                             );


//                       // =========================
//                       // DISPLAY TAX
//                       // =========================

//                       const displayTax =
//                         taxRateString ||
//                         (
//                           itemTaxPercent > 0
//                             ? `${itemTaxPercent.toFixed(2)}%`
//                             : "0.00%"
//                         );


//                       // =========================
//                       // ITEM TAX AMOUNT
//                       // =========================

//                       const itemTaxAmount =
//                         toNumber(
//                           itm.taxAmount ??
//                           0
//                         );


//                       // =========================
//                       // ITEM TOTAL
//                       // =========================

//                       const itemTotal =
//                         toNumber(
//                           itm.total ??
//                           itm.amount ??
//                           (
//                             qty * price
//                           )
//                         );


//                       return `
//                         <tr>

//                           <td>
//                             ${safeText(
//                               itemName,
//                               ""
//                             )}
//                           </td>

//                           <td>
//                             ${qty}
//                           </td>

//                           <td>
//                             ${price.toFixed(2)}
//                           </td>

//                           <td>
//                             ${itemDiscount.toFixed(2)}
//                           </td>

//                           <td>
//                             ${displayTax}
//                           </td>

//                           <td>
//                             ${itemTotal.toFixed(2)}
//                           </td>

//                         </tr>
//                       `;

//                     })
//                     .join("")

//                 : `
//                     <tr>

//                       <td colspan="6">
//                         No Items
//                       </td>

//                     </tr>
//                   `
//             }

//           </tbody>

//         </table>


//         <!-- =========================
//              SUMMARY
//         ========================= -->

//         <div class="summary-section">


//           <!-- LEFT -->

//           <div class="summary-left">

//             <div class="summary-row">

//               <span>
//                 <b>
//                   Total Quantity
//                 </b>
//               </span>

//               <span>
//                 <b>
//                   ${totalQuantity}
//                 </b>
//               </span>

//             </div>


//             <div class="amount-words">

//               <b>
//                 Amount in Words:
//               </b>

//               <br>

//               <b>
//                 ${safeText(
//                   item.amount_words ??
//                   item.amountInWords,
//                   "Total Amount"
//                 )}
//               </b>

//             </div>

//           </div>


//           <!-- RIGHT -->

//           <div class="summary-right">


//             <!-- GROSS AMOUNT -->

//             <div class="summary-row">

//               <span class="summary-label">
//                 Gross Amount
//               </span>

//               <span class="summary-value">
//                 ${grossAmount.toFixed(2)}
//               </span>

//             </div>


//             <!-- TOTAL TAX -->

//             <div class="summary-row">

//               <span class="summary-label">
//                 Total Tax
//               </span>

//               <span class="summary-value">
//                 ${tax.toFixed(2)}
//               </span>

//             </div>


//             <!-- TOTAL DISCOUNT -->

//             <div class="summary-row">

//               <span class="summary-label">
//                 Total Discount
//               </span>

//               <span class="summary-value">
//                 ${discount.toFixed(2)}
//               </span>

//             </div>


//             <!-- PAYABLE -->

//             <div class="summary-row">

//               <span class="summary-label">
//                 Payable Amount
//               </span>

//               <span class="summary-value">
//                 ${total.toFixed(2)}
//               </span>

//             </div>


//             <!-- RECEIVED -->

//             <div class="summary-row">

//               <span class="summary-label">
//                 Received
//               </span>

//               <span class="summary-value">
//                 ${received.toFixed(2)}
//               </span>

//             </div>


//             <!-- DUE -->

//             <div class="summary-row">

//               <span class="summary-label">
//                 Due Amount
//               </span>

//               <span class="summary-value">
//                 ${due.toFixed(2)}
//               </span>

//             </div>

//           </div>

//         </div>


//         <!-- =========================
//              DESCRIPTION
//         ========================= -->

//         <div class="description">

//           <b>
//             Description:
//           </b>

//           ${safeText(
//             item.description,
//             "NA"
//           )}

//         </div>


//         <!-- =========================
//              SIGNATURE
//         ========================= -->

//         <div class="signature">

//           <div class="signature-logo">
//             ✓ Company
//           </div>

//           <div class="signature-text">
//             Authority's Signature
//           </div>

//         </div>


//       </div>


//       <!-- =========================
//            AUTO PRINT
//       ========================= -->

//       <script>

//         window.onload = function() {

//           setTimeout(function() {

//             window.print();

//           }, 500);

//         };


//         window.onafterprint = function() {

//           setTimeout(function() {

//             window.close();

//           }, 300);

//         };

//       </script>

//     </body>

//     </html>
//   `);

//   invoiceWindow.document.close();
// };

// const handleDownload = (item) => {
//   let items = [];

//   try {
//     items = Array.isArray(item.items)
//       ? item.items
//       : JSON.parse(item.items || "[]");
//   } catch (error) {
//     console.log("Items parse error:", error);
//     items = [];
//   }

//   const total = Number(item.payable || 0);
//   const discount = Number(item.discount || 0);
//   const tax = Number(item.tax || 0);
//   const received = Number(item.received || 0);
//   const due = Number(item.due || 0);

//   const grossAmount = total + discount;

//   const invoiceWindow = window.open("", "_blank", "width=900,height=700");

//   invoiceWindow.document.write(`
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <title>Tax Invoice - ${item.invoiceNo || ""}</title>

//       <style>
//         * {
//           box-sizing: border-box;
//         }

//         body {
//           margin: 0;
//           padding: 0;
//           background: #333;
//           font-family: Arial, Helvetica, sans-serif;
//           color: #222;
//         }

//         .invoice-page {
//           width: 210mm;
//           min-height: 297mm;
//           margin: 10px auto;
//           background: white;
//           padding: 8mm;
//           position: relative;
//         }

//         .invoice-title {
//           text-align: center;
//           color: #a020b5;
//           font-size: 14px;
//           font-weight: bold;
//           margin-bottom: 2px;
//         }

//         .company-box {
//           border: 1px solid #c22bd2;
//           padding: 5px;
//           min-height: 45px;
//         }

//         .company-name {
//           color: #a020b5;
//           font-size: 12px;
//           font-weight: bold;
//         }

//         .company-details {
//           font-size: 8px;
//           line-height: 11px;
//         }

//         .customer-row {
//           display: flex;
//           justify-content: space-between;
//           margin-top: 5px;
//           font-size: 8px;
//           line-height: 11px;
//         }

//         .customer-left {
//           width: 50%;
//         }

//         .customer-right {
//           width: 35%;
//         }

//         table {
//           width: 100%;
//           border-collapse: collapse;
//         }

//         .items-table {
//           margin-top: 5px;
//           font-size: 8px;
//         }

//         .items-table th {
//           background: #9c27b0;
//           color: white;
//           border: 1px solid #555;
//           padding: 4px;
//           text-align: center;
//         }

//         .items-table td {
//           border: 1px solid #555;
//           padding: 4px;
//           text-align: center;
//         }

//         .summary-section {
//           display: flex;
//           margin-top: 4px;
//           font-size: 8px;
//         }

//         .summary-left {
//           width: 50%;
//         }

//         .summary-right {
//           width: 50%;
//         }

//         .summary-row {
//           display: flex;
//           justify-content: space-between;
//           padding: 1px 0;
//         }

//         .summary-label {
//           color: #a020b5;
//           font-weight: bold;
//         }

//         .summary-value {
//           font-weight: bold;
//         }

//         .description {
//           margin-top: 8px;
//           font-size: 8px;
//         }

//         .signature {
//           position: absolute;
//           bottom: 10mm;
//           left: 8mm;
//           font-size: 8px;
//         }

//         .signature-logo {
//           color: green;
//           font-size: 9px;
//           font-weight: bold;
//           margin-bottom: 15px;
//         }

//         .signature-text {
//           font-weight: bold;
//         }

//         @media print {
//           body {
//             background: white;
//           }

//           .invoice-page {
//             margin: 0;
//             width: 210mm;
//             min-height: 297mm;
//             box-shadow: none;
//           }
//         }
//       </style>
//     </head>

//     <body>

//       <div class="invoice-page">

//         <div class="invoice-title">
//           TAX INVOICE
//         </div>

//         <div class="company-box">
//           <div class="company-name">
//             ${item.company_name || "TESTING ACCOUNT"}
//           </div>

//           <div class="company-details">
//             GSTIN: ${item.gstin || "86575GDFGR6"}<br>
//             CONTACT: ${item.contact || "NA"}<br>
//             ADDRESS: ${item.company_address || "GEORGE TOWN, PRAYAGRAJ"}
//           </div>
//         </div>

//         <div class="customer-row">

//           <div class="customer-left">
//             <b>Billed To:</b> ${item.name || "Cash Customer"}<br>
//             <b>Address:</b> ${item.address || "NA"}<br>
//             <b>Contact:</b> ${item.mobile || "NA"}
//           </div>

//           <div class="customer-right">
//             <b>Invoice Number:</b> ${item.invoiceNo || ""}<br>
//             <b>Invoice Date:</b> ${item.date || ""}<br>
//             <b>Customer GST:</b> ${item.customer_gst || ""}
//           </div>

//         </div>

//         <table class="items-table">
//           <thead>
//             <tr>
//               <th>Item Name</th>
//               <th>Qty</th>
//               <th>Unit Price</th>
//               <th>Discount</th>
//               <th>Tax</th>
//               <th>Total</th>
//             </tr>
//           </thead>

//           <tbody>

//             ${
//               items.length > 0
//                 ? items.map((itm) => {

//                     const qty = Number(
//                       itm.qty || itm.quantity || 0
//                     );

//                     const price = Number(
//                       itm.price ||
//                       itm.unitPrice ||
//                       itm.rate ||
//                       itm.unit_price ||
//                       0
//                     );

//                     const itemDiscount = Number(
//                       itm.discount || 0
//                     );

//                     const itemTax = Number(
//                       itm.tax || 0
//                     );

//                     const itemTotal = Number(
//                       itm.total ||
//                       itm.amount ||
//                       qty * price ||
//                       0
//                     );

//                     return `
//                       <tr>
//                         <td>${itm.name || itm.item || itm.item_name || ""}</td>
//                         <td>${qty}</td>
//                         <td>${price.toFixed(2)}</td>
//                         <td>${itemDiscount.toFixed(2)}</td>
//                         <td>${itemTax}%</td>
//                         <td>${itemTotal.toFixed(2)}</td>
//                       </tr>
//                     `;
//                   }).join("")
//                 : `
//                     <tr>
//                       <td colspan="6">No Items</td>
//                     </tr>
//                   `
//             }

//           </tbody>
//         </table>

//         <div class="summary-section">

//           <div class="summary-left">

//             <div class="summary-row">
//               <span><b>Total Quantity</b></span>
//               <span>
//                 <b>
//                   ${items.reduce(
//                     (sum, itm) =>
//                       sum +
//                       Number(itm.qty || itm.quantity || 0),
//                     0
//                   )}
//                 </b>
//               </span>
//             </div>

//             <div style="margin-top:8px;">
//               <b>Amount in Words -</b><br>
//               <b>${item.amount_words || "Total Amount"}</b>
//             </div>

//           </div>

//           <div class="summary-right">

//             <div class="summary-row">
//               <span class="summary-label">Gross Amount</span>
//               <span class="summary-value">
//                 ${grossAmount.toFixed(2)}
//               </span>
//             </div>

//             <div class="summary-row">
//               <span class="summary-label">Total Tax</span>
//               <span class="summary-value">
//                 ${tax.toFixed(2)}
//               </span>
//             </div>

//             <div class="summary-row">
//               <span class="summary-label">Total Discount</span>
//               <span class="summary-value">
//                 ${discount.toFixed(2)}
//               </span>
//             </div>

//             <div class="summary-row">
//               <span class="summary-label">Payable Amount</span>
//               <span class="summary-value">
//                 ${total.toFixed(2)}
//               </span>
//             </div>

//             <div class="summary-row">
//               <span class="summary-label">Received</span>
//               <span class="summary-value">
//                 ${received.toFixed(2)}
//               </span>
//             </div>

//             <div class="summary-row">
//               <span class="summary-label">Due Amount</span>
//               <span class="summary-value">
//                 ${due.toFixed(2)}
//               </span>
//             </div>

//           </div>

//         </div>

//         <div class="description">
//           <b>Description:</b>
//           ${item.description || ""}
//         </div>

//         <div class="signature">

//           <div class="signature-logo">
//             ✓ Company
//           </div>

//           <div class="signature-text">
//             Authority's Signature
//           </div>

//         </div>

//       </div>

//       <script>
//         window.onload = function() {
//           setTimeout(function() {
//             window.print();
//           }, 500);
//         };

//         window.onafterprint = function() {
//           window.close();
//         };
//       </script>

//     </body>
//     </html>
//   `);

//   invoiceWindow.document.close();
// };
  const fetchSaleHistory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-sale-history/${clientData.id}`);
      console.log(res,res.data)

      const sortedData = [...res.data].sort((a, b) => b.invoiceNo - a.invoiceNo);

      setExpenseBill(sortedData);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSaleHistory();

  }, []);

  // const filteredData = Array.isArray(expenseBill)
  //   ? expenseBill
  //     .filter((itm) =>
  //       Object.values(itm).some((val) =>
  //         String(val).toLowerCase().includes(searchTerm.toLowerCase())
  //       )
  //     )
  //   : [];

  const filteredData = Array.isArray(expenseBill)
  ? expenseBill.filter((itm) => {
      const partyMatch =
        !partySearchTerm ||
        (itm.name || "")
          .toLowerCase()
          .includes(partySearchTerm.toLowerCase()) ||
        String(itm.mobile || "")
          .toLowerCase()
          .includes(partySearchTerm.toLowerCase());

      const invoiceMatch =
        !invoiceSearch ||
        String(itm.invoiceNo || "")
          .toLowerCase()
          .includes(invoiceSearch.toLowerCase());

      return partyMatch && invoiceMatch;
    })
  : [];

  return (

    <div className="container-fluid py-4">
      <div className="card shadow border-0 rounded-4">

  <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap">
  {/* Left Side */}
  <h4 className="mb-0 fw-bold">
    All Sale History
  </h4>

  {/* Right Side */}
  <div
    className="d-flex align-items-center gap-2 flex-wrap justify-content-end"
  >
    <SearchBox
      placeholder="Customer Name / Number"
      value={partySearchTerm}
      onChange={(e) => setPartySearchTerm(e.target.value)}
    />

    <SearchBox
      placeholder="Invoice Number"
      value={invoiceSearch}
      onChange={(e) => setInvoiceSearch(e.target.value)}
    />

    <button
      className="btn btn-primary"
      onClick={() => navigate("/home")}
    >
      Back
    </button>
  </div>
</div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead >
                <tr>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Inv.No</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Customer Name</th>

                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Date </th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Payment Mode</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Total</th>
                  <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Activity</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center text-muted">
                      No Transaction Found
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{item.invoiceNo}</td>
                      <td>{item.name}</td>
                      <td>{item.date}</td>
                      <td>{item.payment_method}</td>
                      <td> ₹{item.payable || 0}</td>

                      <td>

       

<div className="d-flex gap-2">
  {/* <button
    className="btn btn-primary"
    onClick={() =>
      navigate("/add-sale", {
        state: item,
      })
    }
  >
    Edit
  </button> */}
  <button
  className="btn btn-primary"
  onClick={() =>
    navigate("/add-sale", {
      state: {
        ...item,
        editMode: true,
        fromSaleHistory: true,
      },
    })
  }
>
  Edit
</button>

<button
  className="btn btn-primary"
  title="Download Invoice"
  onClick={() => handleDownload(item)}
>
  <i className="bi bi-download"></i>
</button>
</div>

                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SaleHistory


const SearchBox = ({ placeholder, value, onChange }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      border: "2px solid #ff5d94",
      borderRadius: "8px",
      overflow: "hidden",
      background: "#fff",
      flex: "1",
      minWidth: "220px",
    }}
  >
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{
        border: "none",
        outline: "none",
        padding: "8px 12px",
        width: "100%",
        width: "100%",
        minWidth: "150px",
      }}
    />

    <div
      style={{
        padding: "0 10px",
        color: "#1d8cf8",
      }}
    >
      <FaSearch />
    </div>
  </div>
);